import 'babel-polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

svg4everybody();
window.$ = $;
window.jQuery = $;

require('slick-carousel');
require('jquery-autocomplete');
require('ion-rangeslider');
require('masonry-layout/dist/masonry.pkgd');
require('perfect-scrollbar/dist/perfect-scrollbar');
require('sharer.js/sharer');
require('tooltip.js');



// WEBPACK FOOTER //
// ./src/js/vendor.js